/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, bohdev, crocowebdev@gmail.com
 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { Button, getProperty } from "trux"
import * as act from "./actions"
import { webApi } from "../../lib/WebApi"
import { AddMomentToTraceiD } from "../AddMomentToTraceiD"
import { PersonalizeMoment } from "../PersonalizeMoment"

const initialState = {
    shown: true,
    rating: 0,
    step: "preview",
    transition: "empty",
    spotlight: null,
    spotlightEnabled: true,
    allTags: [],
    good: {
        category: "attacking",
        technique: 0,
        pass: 0,
        off_ball_movement: 0,
        shot: 0,
        cross: 0,
        goal: 0,
        final_pass: 0,
        attacking_heading: 0,
        attacking_set_piece: 0,
        attack_transition: 0,
        touch: 0,
        counter_attack: 0,

        one_on_one_defense: 0,
        defensive_set_piece: 0,
        defensive_position: 0,
        defensive_decisions: 0,
        defensive_heading: 0,
        defense_transition: 0,
        tackle: 0,

        gk_from_hands: 0,
        gk_from_feet: 0,
        gk_crosses: 0,
        gk_saves: 0,
        gk_breakaway: 0,
    },
    selectedUser: null,
}

class SaveClipDialog extends Component {
    constructor(props) {
        super(props)

        this.state = Object.assign({}, initialState)

        this.onSend = this.onSend.bind(this)
        this.onNoSpotlight = this.onNoSpotlight.bind(this)

        this.onGoodOptionChanged = this.onGoodOptionChanged.bind(this)

        this.showStepTwo = this.showStepTwo.bind(this)
        this.onSpotlightChange = this.onSpotlightChange.bind(this)
        this.backContent = this.backContent.bind(this)
        this.onClose = this.onClose.bind(this)
        this.setCategory = this.setCategory.bind(this)
        this.createPlaylist = this.createPlaylist.bind(this)
    }

    componentDidMount() {

        let event = new CustomEvent("trc-pause")
        document.dispatchEvent(event)
        webApi.getGeneralTagsList().then((data) => {
            if (data.success) {
                let good = { category: "attacking" }
                for (let tag of data.result) {
                    if (tag.enabled) {
                        good[tag.name] = 0
                    }
                }
                this.setState({ allTags: data.result, good: good })
                this.queryUserTags()
            }
        })
        document.dispatchEvent(new CustomEvent("trc-pause"))

        if (this.props.isBeta) {
            if (this.props.relations?.length === 1) {
                this.selectFamilyMember(this.props.relations[0].user)
            } else {
                let firstStep = "select-user"
                this.setState({ step: firstStep })
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isBeta !== this.props.isBeta && this.props.isBeta) {
            if (this.props.relations?.length === 1) {
                this.selectFamilyMember(this.props.relations[0].user)
            } else {
                let firstStep = "select-user"
                this.setState({ step: firstStep })
            }
        }
    }

    queryUserTags() {
        let clipId = getProperty("clip.game_clip_id", this.props, null)
        let userId = getProperty("user.user_id", this.props, null)
        webApi.getClipTags(clipId, userId).then((data) => {
            if (data.success) {
                console.log("LOADED TAGS: ", data)
                let rows = data.result[0].data ? data.result[0].data.data : []
                let good = this.state.good
                for (let item of rows) {
                    let found = this.state.allTags.find(
                        (t) => t.title === item.name
                    )
                    if (found) {
                        good[found.name] = 1
                    }
                }
                this.setState({ good: good })
            }
        })
    }

    onSpotlightChange(spot) {
        this.setState({ spotlight: spot })
    }

    showStepTwo(e) {
        e.preventDefault()
        this.setState({ step: "tags" })
    }

    backContent(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({ step: "spotlight" })
    }

    onSend(e) {
        if (e) {
            e.preventDefault()
        }

        this.sendFeedback()
    }

    onGoodOptionChanged(e) {
        let key = e.currentTarget.id
        let val = this.state.good[key] === 1 ? 0 : 1

        let update = {}
        update[key] = val

        console.log("TAG UPDATE", update)
        let good = Object.assign({}, this.state.good, update)
        this.setState({ good: good })
    }

    setCategory(cat) {
        let good = Object.assign({}, this.state.good, { category: cat })
        this.setState({ good: good })
    }

    //// General Event handlers

    onClose(e) {
        if (e) {
            e.preventDefault()
        }

        let url = this.props.location.pathname
            .replace(/^#\//gi, "/")
            .replace(/\/save\/prof.*$/, "")
        this.props.history.push(url)
        document.dispatchEvent(new CustomEvent("trc-play"))
    }
    onNoSpotlight(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({ step: "tags", spotlightEnabled: false })
    }

    onSpotlightToggle(e) {
        e.preventDefault()
        this.setState({ spotlightEnabled: !this.state.spotlightEnabled })
    }

    //// Send Feedback Logic

    sendFeedback() {
        let clipTags = []
        for (let tag of this.state.allTags) {
            if (this.state.good[tag.name] === 1) {
                clipTags.push(tag.title)
            }
        }

        let tn = ""
        for (let key in this.props.game.athletes) {
            let athlete = this.props.game.athletes[key]
            if (athlete.user_id === this.props.user.user_id) {
                tn = athlete.id
            }
        }

        let gameId = this.props.match.params.game_id
        let user = this.props.user
        let clip = this.props.clip
        if (this.state.spotlightEnabled) {
            clip._spotlights = [
                {
                    corr: 0,
                    trace_number: tn,
                    user_id: user.user_id,
                    width: 34 * this.state.spotlight.scale,
                    utc:
                        clip.utc_time -
                        clip.dynamic.offset * 1000 +
                        this.state.spotlight.time * 1000,
                    height: 0,
                    center: [this.state.spotlight.x, this.state.spotlight.y],
                },
            ]
        } else {
            clip._spotlights = [{ user_id: user.user_id }]
        }
        console.log(
            "saving clip",
            gameId,
            user,
            clip,
            clipTags,
            this.state.spotlightEnabled
        )
        console.log(
            "saving spotlights",
            clip._spotlights,
            clip.utc_time,
            clip.dynamic_offset,
            this.state.spotlight
        )

        this.setState({ step: "sending" })
        let that = this
        this.props.save(gameId, user, clip, clipTags, (success) => {
            console.log("save clip success", success)
            if (success) {
                that.setState({ step: "success" })
            } else {
                that.setState({ step: "failure" })
            }
        })
    }

    selectFamilyMember(user) {
        let selectedUser = Object.assign({}, user)
        selectedUser.name = user.first_name + " " + user.last_name
        this.setState({ selectedUser: selectedUser, step: "save-to-playlist" })
    }

    createPlaylist() {
        this.setState({ step: "create-playlist" })
    }

    render() {
        let userId = getProperty("user.user_id", this.props, "na")
        let idLink = `https://id.traceup.com/find/user/${userId}`
        document.dispatchEvent(new CustomEvent("trc-pause"))

        return (
            <>
                {!this.props.isBeta && (
                    <PersonalizeMoment
                        onClose={this.onClose}
                        step={this.state.step}
                        clip={this.props.clip}
                        teamName={this.props.match.params.team_name}
                        gameId={this.props.match.params.game_id}
                        setStep={(step) => this.setState({ step: step })}
                        checked={this.state.spotlightEnabled}
                        onToggle={(e) => this.onSpotlightToggle(e)}
                        disabled={!this.state.spotlightEnabled}
                        spotlight={this.state.spotlight}
                        onSpotlightChange={this.onSpotlightChange}
                        showStepTwo={this.showStepTwo}
                        allTags={this.state.allTags}
                        tags={this.state.good}
                        category={this.state.good.category}
                        setCategory={this.setCategory}
                        onSend={this.onSend}
                        toggleTag={this.onGoodOptionChanged}
                        idLink={idLink}
                    />
                )}

                {this.props.isBeta && (
                    <AddMomentToTraceiD
                        onClose={this.onClose}
                        step={this.state.step}
                        selectFamilyMember={(familyMember) =>
                            this.selectFamilyMember(familyMember)
                        }
                        setStep={(step) => this.setState({ step: step })}
                        selectedUser={this.state.selectedUser}
                        createPlaylist={this.createPlaylist}
                        relations={this.props.relations}
                        trkContext="Add Moment to Trace IDv2"
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = (state, pageProps) => {
    return {
        user: state.user.value,
        game: state.game.value,
        clip: state.video.value.source,
        isUserLoaded: state.user.complete,
        isUserLoggedIn: state.isLoggedIn,
        show: state.user.complete && state.isLoggedIn,
        returnUrl: window.location.href,
        rev: Date.now(),
        isBeta: state.acl.value.traceid_v2,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        save: (gameId, user, clip, tags, cb) => {
            dispatch(act.saveClipToProfile(gameId, user, clip, tags, cb))
        },
    }
}

export const SaveClip = connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveClipDialog)

export const TagEditor = ({
    allTags,
    tags,
    category,
    setCategory,
    toggleTag,
    onSend,
}) => {
    let curTags = allTags.filter((i) => {
        return (
            i.category === category &&
            (i.enabled || this.state.good[i.name] > 0)
        )
    })
    return (
        <form onSubmit={onSend}>
            <p className="button-group">
                <Button
                    primary={category === "attacking"}
                    content="Attack"
                    onClick={(e) => {
                        e.preventDefault()
                        setCategory("attacking")
                    }}
                    small
                />
                <Button
                    primary={category === "defense"}
                    content="Defense"
                    onClick={(e) => {
                        e.preventDefault()
                        setCategory("defense")
                    }}
                    small
                />
                <Button
                    primary={category === "goalkeeper"}
                    content="GK"
                    onClick={(e) => {
                        e.preventDefault()
                        setCategory("goalkeeper")
                    }}
                    small
                />
            </p>
            <div className="tags">
                {curTags.map((tag) => {
                    return (
                        <div className="tag" key={`reason-tag-${tag.name}`}>
                            <input
                                type="checkbox"
                                id={tag.name}
                                data-trk-act="Tag Toggle"
                                onChange={toggleTag}
                                value="1"
                                checked={tags[tag.name] === 1}
                            />
                            <label data-trk-act="Tag Toggle" htmlFor={tag.name}>
                                {tag.title}
                            </label>
                        </div>
                    )
                })}
            </div>
        </form>
    )
}
